import FieldProto from "../../../../fields3/proto/field-proto"
import FieldConfig from "../../../proto/field-config";
import FieldDocumentType_View from "./render/view";
import FieldDocumentType_ViewSmall from "./render/view-small";
import FieldDocumentType_GlistGroupStandard from "./components/glist-group/standard";

const debug = false
// const debug = "FieldDocumentType"

export default class FieldDocumentType extends FieldProto {

    // G_LIST_CLASS = FieldDocumentTypeGList

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel  = "Document type"
        this.label      = "Document type"
        this.icon       = 'ii5-wiki'

        _.assign(this.components,{
            glistGroupStandard      : FieldDocumentType_GlistGroupStandard
        })

        _.assign(this.renderComponents,{
            view                : FieldDocumentType_View,
            viewSmall           : FieldDocumentType_ViewSmall
        })
    }

    sortValue(value:any, model?:any) {
        const noteType = gd.session.noteTypes.get(value)
        return noteType ? noteType.name : ''
    }

    groupValue(value:any) {return value}

    groupSortValue(value:any) {
        return this.sortValue(value)
    }

}